import { lightTheme as theme } from '@zenbusiness/zui/styles';

export const COLOR_HISTORY_BALANCE = {
  Y_TICK: theme.palette.background.grey.dark,
  TOOLTIP_BACKGROUND: theme.palette.fixed.black,
  TOOLTIP_TEXT: theme.palette.background.grey.main,
  LINE: theme.palette.background.green.main,
  NO_DATA_LINE: theme.palette.background.grey.main,
  NO_DATA_TEXT: theme.palette.background.grey.dark,
  IN: theme.palette.background.green.main,
  OUT: theme.palette.fixed.black
};
